package com.yogaaicoach.pages.auth.firebase

class FirebaseService() {
    fun mapErrorMessage(err: Throwable): String {
        if (err is AuthError) return err.message

        val mappedError = if (err.message != null) {
            when {
                err.message!!.contains("invalid-email", ignoreCase = true) ->
                    AuthError.InvalidEmail()

                err.message!!.contains("email-already-in-use", ignoreCase = true) ->
                    AuthError.EmailAlreadyInUse()

                err.message!!.contains("weak-password", ignoreCase = true) ->
                    AuthError.WeakPassword()
                err.message!!.contains("auth/user-not-found", ignoreCase = true) ->
                    AuthError.UserNotFound()
                err.message!!.contains("auth/invalid-credential", ignoreCase = true) ->
                    AuthError.InvalidCredentials()
                err.message!!.contains("TOO_MANY_ATTEMPTS_TRY_LATER", ignoreCase = true) ->
                    AuthError.TooManyAttempts()

                else -> AuthError.Unknown()
            }
        } else {
            AuthError.Unknown()
        }
        return mappedError.message
    }

}